import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import { useToken, Box } from '@hausgold/designsystem';
import { jsx } from '@emotion/react';
var _excluded = ["iconSvg", "color", "w", "h"],
  _excluded2 = ["iconId"];
var DynamicIcon = function DynamicIcon(_ref) {
  var iconSvg = _ref.iconSvg,
    color = _ref.color,
    w = _ref.w,
    h = _ref.h,
    props = _objectWithoutProperties(_ref, _excluded);
  // Get hex of given color or use default one.
  var iconColor = useToken('colors', color, 'colors.blue.400');

  // Return nothing if svg isn't set
  if (!iconSvg) {
    return null;
  }
  props.iconId;
  var boxProps = _objectWithoutProperties(props, _excluded2);

  // Replace "auto" on height and width with "100%" as "auto" is not aligned
  var transformAuto = function transformAuto(dimension) {
    return dimension === 'auto' ? '100%' : dimension;
  };

  // Format svg to our needs
  var svg = iconSvg
  // Replace "placeholder" colors with specific one.
  // "currentColor" seems not to work with the implementation, so we set the correct color right away.
  .replace(/#1098F3/g, iconColor).replace(/#1694F4/g, iconColor).replace(/#0071B9/g, iconColor).replace(/currentColor/g, iconColor)
  // Overwrite svg props with given styles
  // Example svg tag: <svg width="24px" height="24px">...</svg>
  .replace(/width="[^"]*"/, "width=".concat(transformAuto(w))).replace(/height="[^"]*"/, "height=".concat(transformAuto(h)));

  // Render raw html (svg)
  return jsx(Box, _extends({
    dangerouslySetInnerHTML: {
      __html: svg
    },
    display: "inline-block",
    lineHeight: "1em"
  }, boxProps));
};
DynamicIcon.propTypes = {
  iconSvg: PropTypes.string,
  iconId: PropTypes.string,
  color: PropTypes.string,
  w: PropTypes.string,
  h: PropTypes.string
};
DynamicIcon.defaultProps = {
  iconSvg: null,
  iconId: null,
  color: null,
  // Defaults of every Icon
  w: '24px',
  h: '24px'
};
export { DynamicIcon as default };